import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import Button from "../../../../components/elements/Button/Button";
import Selector from "../../../../components/elements/Selector/Selector";
import ModalComp from "../../../../components/ModalComp/ModalComp";

export default function EventSheetAddField({
                                               modalIsOpen,
                                               setModalIsOpen,
                                               onAdd,
                                               sectionOptions,
                                               sections,
                                               sectionKey,
                                               fieldKey
                                           }) {
    const intl = useIntl();
    const [selected, setSelected] = useState(null);
    const [fieldWidth, setFieldWidth] = useState("col-12"); // default full width
    useEffect(() => {
        if (fieldKey) {
            setSelected(fieldKey ? sections[sectionKey][fieldKey].value : null)
            setFieldWidth(fieldKey ? sections[sectionKey][fieldKey].width : "col-12")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldKey])

    const handleAdd = () => {
        if (selected) {
            let item =  sectionOptions.find(item => item.value === sectionKey).fields
                .find(item => item.value ===selected)

            if (fieldKey){
                item = sections[sectionKey][fieldKey]
            }
            item.width = fieldWidth
            onAdd({...item});
            setModalIsOpen(false);
            setSelected(null);
            setFieldWidth("col-12");
        }
    };

    return (
        <ModalComp
            title={intl.formatMessage({id: 'settings.event_sheet_templates.add_field'})}
            isOpen={modalIsOpen}
            className={"sign-contract"}
            close={true}
            onRequestClose={() => setModalIsOpen(false)}
        >
            <div className={"content"} style={{height: "unset", maxHeight: "unset"}} key={selected}>
                <div className="row">
                    <div className="col-12">
                        <div className="form-control">
                            <div
                                className="form-label">{intl.formatMessage({id: "general.field"})}</div>
                            <Selector
                                disabled={!!fieldKey}
                                options={sectionOptions && sectionOptions.find(item => item.value === sectionKey) ?
                                    (!fieldKey ?
                                            //daca avem adaugare le filtram, sa nu poata adauga duplicate
                                            sectionOptions.find(item => item.value === sectionKey).fields
                                                .filter(item => !Object.keys(sections[sectionKey]).includes(item.value))
                                            :
                                            sectionOptions.find(item => item.value === sectionKey).fields
                                    ) : []}
                                value={selected}
                                onChange={(option) => {
                                    setSelected(option.value)
                                    setFieldWidth(option.width ?? "col-12");
                                }}
                                placeholder={intl.formatMessage({id: 'settings.event_sheet_templates.select_field'})}
                            />
                        </div>
                    </div>

                    {selected && <div className="col-12">
                        {/* Selectăm dimensiunea */}
                        <div className="form-control">
                            <div
                                className="form-label">{intl.formatMessage({id: "general.layout"})}</div>
                            <Selector
                                className="form-select"
                                key={fieldWidth}
                                value={fieldWidth}
                                options={[{
                                    value: 'col-12',
                                    label: intl.formatMessage({id: "general.layout.full_width"})
                                }, {
                                    value: 'col-6',
                                    label: intl.formatMessage({id: "general.layout.half_width"})
                                }]}
                                onChange={(option) => setFieldWidth(option.value)}
                            />
                        </div>
                    </div>}
                    <div className="col-12 mt-3 d-flex justify-content-end">

                        <Button
                            className="btn-error"
                            icon="fa-solid fa-xmark"
                            value={intl.formatMessage({id: 'general.buttons.cancel'})}
                            onClick={() => setModalIsOpen(false)}
                        />
                        <Button
                            className="btn-primary ms-auto"
                            icon={"fa-solid fa-" + (!!fieldKey ? "floppy-disk" : "plus")}
                            value={intl.formatMessage({id: 'general.buttons.' + (!!fieldKey ? 'save' : 'add')})}
                            onClick={handleAdd}
                            disabled={!selected}
                        />
                    </div>
                </div>
            </div>
        </ModalComp>
    );
}
